import { render, staticRenderFns } from "./QuotedParts.vue?vue&type=template&id=0872978e&scoped=true&"
import script from "./QuotedParts.vue?vue&type=script&lang=ts&"
export * from "./QuotedParts.vue?vue&type=script&lang=ts&"
import style0 from "./QuotedParts.vue?vue&type=style&index=0&id=0872978e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872978e",
  null
  
)

export default component.exports